<div *ngIf="usuarioAutenticadoP" [hidden]="!data.status" id="show-cargaModal" data-bs-toggle="modal" data-bs-target="#cargaModal" class="content-load">
    <div class="justify-content-center loading">
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>

<div class="modal fade" id="cargaModal" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="tarefasModalLabel" aria-hidden="true" >
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h1 class="modal-title fs-5" >Status da Carga</h1>
            <button id="close_carga_modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
         </div>
         <div class="modal-body d-grid gap-3">
            <div class="card-body d-grid gap-2">
                <label for="">Processamento da carga de Entrada: {{data.ent_read}}</label>
                <div class="progress" role="progressbar" aria-label="Example 10px high" attr.aria-valuenow="{{pctEnt}}" aria-valuemin="0" attr.aria-valuemax="{{data.ent_read}}" style="height: 40px; font-size: large">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="pctEnt" >{{pctEnt}}%</div>
                </div>
                <label for="">Processamento da carga de Saida: {{data.ent_proc}}</label>
                <div class="progress" role="progressbar" aria-label="Example 10px high" attr.aria-valuenow="{{pctSai}}" aria-valuemin="0" attr.aria-valuemax="{{data.ent_proc}}" style="height: 40px; font-size: large">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="pctSai">{{pctSai}}%</div>
                </div>
                <!-- <label for="">Notas com Erro: {{data.ent_erro}}</label>
                <div class="progress" role="progressbar" aria-label="Example 1px high" attr.aria-valuenow="{{pctErro}}" aria-valuemin="0" attr.aria-valuemax="{{data.ent_erro}}" style="height: 40px; font-size: large">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" [style.width.%]="pctErro">{{pctErro}}%</div>
                </div> -->
            </div>

            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-header">Entradas</div>
                        <div class="card-body d-grid justify-content-center">
                            <div id="gaugeChartSatatusEnt"></div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-header">Saídas</div>
                        <div class="card-body d-grid justify-content-center">
                        <div id="gaugeChartSatatusSai"></div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </div>
    </div>
</div>